import Link from 'next/link';
import Image from 'next/image';
import { Styles } from './styles';
import { Courses } from '../../../types/schema';

export type PopularCourseProps = {
  courses: Courses[];
};

const PopularCourse: React.FC<PopularCourseProps> = ({ courses }) => {
  return (
    <Styles>
      {/* Popular Course */}
      <div className="popular-course">
        <h5>Veja também</h5>
        <div className="popular-items">
          {courses.map((data, i) => (
            <div className="item-box d-flex" key={i}>
              <div className="item-img">
                <Link href={data.slug}>
                  <Image
                    className="img"
                    width={85}
                    height={85}
                    quality={60}
                    src={data.image?.url || ''}
                    alt="Imagem do curso"
                  />
                </Link>
              </div>
              <div className="item-content">
                <p className="title">
                  <Link href={data.slug}>{data.title}</Link>
                </p>
                {/* {data.subscriptionType === 'free' ? (
                  <p className="price">{CoursesSubscriptionTypeMap[data.subscriptionType]}</p>
                ) : (
                  <p className="price">{`R$ ${data.price}`}</p>
                )} */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Styles>
  );
};

export default PopularCourse;
